import { createEntityQueryKeys } from '@/shared/lib'

export const balanceKeys = createEntityQueryKeys(['balances'])
